import axios from 'axios';


// Gets the logged in user data from local session 
  const APIURL = process.env.REACT_APP_API_URL;
const getLoggedInUser = () => {
    const user = localStorage.getItem('user');
    if (user)
        return JSON.parse(user);
    return null;
}

//is user is logged in
const isUserAuthenticated = () => {
    return getLoggedInUser() !== null;
}

// Register Method
const postFakeRegister = (url, data) => {
    return axios.post(url, data).then(response => {
        if (response.status >= 200 || response.status <= 299)
            return response.data;
        throw response.data;
    }).catch(err => {
        var message;
        if (err.response && err.response.status ) {
            switch (err.response.status) {
                case 404: message = "Sorry! the page you are looking for could not be found"; break;
                case 500: message = "Sorry! something went wrong, please contact our support team"; break;
                case 401: message = "Invalid credentials"; break;
                default: message = err[1]; break;
            }
        }
        throw message;
    });

}

// Login Method
const postFakeLogin = (url, data) => {
    return axios.post(url, data).then(response => {
        if (response.status === 400 || response.status === 500)
            throw response.data;
        return response.data;
    }).catch(err => {
        throw err[1];
    });
}

// postForgetPwd 
const postFakeForgetPwd = (url, data) => {
    return axios.post(url, data).then(response => {
        if (response.status === 400 || response.status === 500)
            throw response.data;
        return response.data;
    }).catch(err => {
        throw err[1];
    });
}


// Login Method
const postJwtProfile = (url, data) => {
    return axios.post(url, data,{ headers: { Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6ImFkbWluIiwiYWRtaW4iOnRydWUsImp0aSI6ImQ2MTEwYzAxLWMwYjUtNDUzNy1iNDZhLTI0NTk5Mjc2YjY1NiIsImlhdCI6MTU5MjU2MDk2MCwiZXhwIjoxNTkyNTY0NjE5fQ.QgFSQtFaK_Ktauadttq1Is7f9w0SUtKcL8xCmkAvGLw'} }).then(response => {
        if (response.status === 400 || response.status === 500)
            throw response.data;
        return response.data;
    }).catch(err => {
        throw err[1];
    });
}

const postFakeProfile = (url, data) => {
    return axios.post(url, data).then(response => {
        if (response.status === 400 || response.status === 500)
            throw response.data;
        return response.data;
    }).catch(err => {
        throw err[1];
    });
}

// Register Method
const postJwtRegister = (url, data) => {
    return axios.post(url, data).then(response => {
        if (response.status >= 200 || response.status <= 299)
            return response.data;
        throw response.data;
    }).catch(err => {
        var message;
        if (err.response && err.response.status ) {
            switch (err.response.status) {
                case 404: message = "Sorry! the page you are looking for could not be found"; break;
                case 500: message = "Sorry! something went wrong, please contact our support team"; break;
                case 401: message = "Invalid credentials"; break;
                default: message = err[1]; break;
            }
        }
        throw message;
    });
}

// Login Method
// Login Method
const postJwtLogin = (url, data) => {

   
   let formData = new FormData();
   formData.append("username", data.email);
   formData.append("password", data.password);

   return new Promise((resolve, reject) => {

     axios
       .post(`${APIURL}/parents/login`, formData, {
         headers: { "X-Requested-With": "XMLHttpRequest" },
       })
       .then((res) => {
           resolve(res.data);
       })
       .catch((e) => {
           console.log(e)
           if (e?.response?.status===404) {
               reject([
                 "Check your internet connection error 404 not found ",
               ]);
           }else if(e?.response?.status===401){
               reject([
                 "El nombre de usuario oh contraseña no son válidos. Por favor ingrese el nombre de usuario y contraseña correctos",
               ]);
           }
       });
   });
}

// Login Method
const postAutotLogin = (url, data) => {

   
   let formData = new FormData();
   formData.append("token", data.token);
  

   return new Promise((resolve, reject) => {

     axios
       .post(APIURL+url, formData, {
         headers: { "X-Requested-With": "XMLHttpRequest" },
       })
       .then((res) => {
           resolve(res.data);
       })
       .catch((e) => {
          
           if (e.response?.data?.message) {
             // If the error has a response, check the status code
               reject([e.response.data.message]);
           } else {
             // If there is no response, handle the error as needed
             reject(["An unexpected error occurred"]);
           }
       });
   });
}









// postForgetPwd 
const postJwtForgetPwd = (url, data) => {
    return axios.post(url, data).then(response => {
        if (response.status === 400 || response.status === 500)
            throw response.data;
        return response.data;
    }).catch(err => {
        throw err[1];
    });
}


export { getLoggedInUser, isUserAuthenticated, postFakeRegister, postFakeLogin,postFakeProfile, postFakeForgetPwd,postJwtRegister, postJwtLogin, postJwtForgetPwd, postJwtProfile ,postAutotLogin}